import templateUrl from './sub-feature-repository-detail.html';

export const subFeatureRepositoryDetailComponent = {
	bindings: {
                details: '<',
                onEdit: '&',
               // onGoBack: '&'
	},
	templateUrl,
	controller: class SubFeatureRepositoryDetailComponent {	
        }
}


// WEBPACK FOOTER //
// ./src/app/common/components/sub-feature-repository/sub-feature-repository-detail/sub-feature-repository-detail.component.js